import React from 'react';
import { useSelector } from 'react-redux';
import screenFinder from '../../../../../constants/screens/screenFinder';
import screensSteps from '../../../../../constants/screens/screensSteps';
import GlobalSubTopBar from '../../../../../utils/components/GlobalSubTopBar';

function CreateEngTopBar({ isAgentScreen = false }) {
  const currentStep = useSelector(state => state.eng.etc.engStep);
  const data = screenFinder('engagement');
  const creationType = useSelector(state => state.eng.etc.creationType);

  return (
    <GlobalSubTopBar
      data={data}
      currentStep={currentStep}
      backRoute={data.dashboardPath}
      steps={screensSteps}
      creationType={creationType}
      isAgentScreen={isAgentScreen}
    />
  );
}

export default CreateEngTopBar;
